/**
 * @desc 历史数据处理
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.HistoryFulfilmentInRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/historyFulfilment/in`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
